import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {VisitPlanModel} from "../../models/visit-plan.model";

@Injectable({providedIn: 'root'})
export class VisitPlanChannelService extends EntitiesChannel<VisitPlanModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "visitPlan_changed";
  }

  getPartialChannelName(): String {
    return "";
  }

  getCreateChannelName(): String {
    return "visitPlan_created";
  }

}
